import posthog from 'posthog-js'

posthog.init('phc_QR9GG6f2YR0wctXf6IkRO8oi7PiYCNNf7sZ1C0nOaos', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-05-24',
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    autocapture: false,
})

export default {
    install(Vue) {
        Vue.prototype.$posthog = posthog
    }
}

export { posthog }


// WEBPACK FOOTER //
// ./src/postHog.js